import { render, staticRenderFns } from "./FloatingIcon.vue?vue&type=template&id=5466e6f6&scoped=true"
import script from "./FloatingIcon.vue?vue&type=script&lang=js"
export * from "./FloatingIcon.vue?vue&type=script&lang=js"
import style0 from "./FloatingIcon.vue?vue&type=style&index=0&id=5466e6f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5466e6f6",
  null
  
)

export default component.exports